import { type UpdateTravelRequestInputData } from '@webapp/modules/expense/business-logic/types/UpdateTravelRequestInputData'
import { type UpdateTravelRequestPayload } from '../api-models/UpdateTravelRequestPayload'

export const mapUpdateTravelRequestInputDataToApi = (
  input: UpdateTravelRequestInputData
): UpdateTravelRequestPayload => ({
  department: input.secondaryCategoryId,
  // Angular parity: blank details are sent as null
  details: input.details || null,
  purpose: input.purpose,
  // The backend `DecimalField` takes the two-decimal string Angular sent
  travelBudget: input.travelBudget.toFixed(2),
})
